interface RouteMeta {
  title: string;
  description: string;
  h1?: string;
  type?: string;
  group?: string;
  canonicalUrl?: string;
}

export interface Route {
  path: string;
  meta: RouteMeta;
  type: 'main' | 'blog' | 'other' | 'legal';
}

export const BASE_URL = 'https://www.trycurrents.app'

export const routes: Route[] = [
  {
    path: '/',
    type: 'main',
    meta: {
      title: 'Currents - Share Your Diving Adventures | Social Platform for Divers',
      description: 'Connect with fellow divers, save your memories, and discover amazing dive spots. The social app made for the diving community.',
      h1: 'Dive More, Log Less',
      type: 'main',
      group: 'core',
      canonicalUrl: `${BASE_URL}/`
    }
  },
  {
    path: '/pro',
    type: 'main',
    meta: {
      title: 'Currents Pro | Sync Your Dive Computer Data',
      description: 'Seamlessly sync your dive computer data, analyze your progress, and keep your dive history backed up and organized with Currents Pro features.',
      h1: 'Your Dive Data, Your Way',
      type: 'main',
      group: 'core'
    }
  },
  {
    path: '/about',
    type: 'main',
    meta: {
      title: 'About Us | Currents',
      description: 'Making ocean technology work for every diver. Currents helps divers focus on what matters most - exploring and protecting our oceans.',
      h1: 'About Currents',
      type: 'main',
      group: 'core'
    }
  },
  {
    path: '/research',
    type: 'main',
    meta: {
      title: 'Research & Open Source | Currents',
      description: 'Explore our open-source contributions and research initiatives in dive technology. We\'re committed to sharing our core technology with the diving community.',
      h1: 'Research & Open Source',
      type: 'main',
      group: 'core'
    }
  },
  {
    path: '/blog',
    type: 'main',
    meta: {
      title: 'Diving Knowledge Hub | Currents',
      description: 'Expert guides and insights about scuba diving, gear reviews, and diving techniques. Learn from experienced divers and improve your skills.',
      h1: 'Diving Knowledge Hub',
      type: 'main',
      group: 'core'
    }
  },
  {
    path: '/compatibility',
    type: 'main',
    meta: {
      title: 'Device Compatibility | Currents',
      description: 'Check which dive computers are compatible with Currents. Seamlessly sync your dive data from major brands including Shearwater, Suunto, and more.',
      h1: 'Compatible Dive Computers',
      type: 'main',
      group: 'core'
    }
  },
  {
    path: '/privacy-policy',
    type: 'legal',
    meta: {
      title: 'Privacy Policy | Currents',
      description: 'Learn how Currents protects your privacy and handles your data. Read our comprehensive privacy policy and data protection guidelines.',
      h1: 'Privacy Policy',
      type: 'legal',
      group: 'core'
    }
  },
  {
    path: '/terms-of-service',
    type: 'legal',
    meta: {
      title: 'Terms of Service | Currents',
      description: 'Read Currents terms of service. Learn about our policies, user agreements, and guidelines for using the Currents app.',
      h1: 'Terms of Service',
      type: 'legal',
      group: 'core'
    }
  },
  {
    path: '/blog/:slug',
    type: 'blog',
    meta: {
      title: 'Blog Post | Currents',
      description: 'Read our latest diving insights',
    }
  }
];

export const getRouteMeta = (path: string): RouteMeta | undefined => {
  return routes.find(route => route.path === path)?.meta;
};

export default { routes, getRouteMeta }; 